import React, { useState, useEffect } from 'react';
import format from 'date-fns/format';
import { Translate } from '../../../../../../shared/LanguageService';
import { ProjectNews } from '@se360/header-components';
import { useTelemetryContext } from '../../../../../../telemetry/telemetryContext';
import { getUserInfo } from '../../../../../../telemetry/utils';
import { useUserContext } from '../../../../../../shared/context/user-context';
import { ProjectNewsProps } from '@se360/header-components/dist/projectNews/ProjectNews';
import { getUserRole } from './utils/userRoleHelper';

// TODO: Export from header-components
type INewsItem = {
    id: number;
    header: string;
    text: string;
    date: string;
};

export type ProjectNewsLabels = {
    newsTitle: string;
    noNews: string;
    newItem: string;
    notificationTooltip: string;
    notificationTooltipSingular: string;
    closeTooltip: string;
};

interface NewsComponentProps extends ProjectNewsProps {
    userData: string;
}

function wasAbortedOnUnmount(error: Error): boolean {
    return Boolean(error) && error.name === 'AbortError';
}

function transformNewsDataDates(newsItems: INewsItem[]): INewsItem[] {
    return newsItems.map((newsItem) => ({
        ...newsItem,
        date: format(new Date(newsItem.date), 'yyyy-MM-dd')
    }));
}

const NewsComponent = (props: NewsComponentProps) => {
    const { labels, userData } = props;
    const [newsData, setNewsData] = useState([]);

    let { logger } = useTelemetryContext();
    let { user } = useUserContext();

    let userRole = userData ? userData : null;
    let role = getUserRole(userRole);

    let baseAddress = window.appConfig.projectNewsUrl;
    let url = `${baseAddress}?application=Photo&role=${role}`;

    useEffect(() => {
        if (url) {
            const controller = new AbortController();
            const opts = { signal: controller.signal };

            fetch(url, opts)
                .then((response) => response.json())
                .then((data) => {
                    let newsItems = transformNewsDataDates(data);
                    setNewsData(newsItems);
                })
                .catch((error) => {
                    if (wasAbortedOnUnmount(error)) {
                        return;
                    }
                    if (logger) {
                        let additionalInfo = {
                            origin: 'NewsComponentDataLayer.fetch_news_items',
                            userInfo: getUserInfo(user)
                        };
                        logger.logException(error, additionalInfo);
                    }
                });

            return () => {
                controller.abort();
            };
        }
    }, [url]);

    if (newsData.length > 0) {
        return <ProjectNews labels={labels} newsItems={newsData} />;
    }

    return <ProjectNews labels={labels} newsItems={[]} />;
};

function TranslatedProjectNews(props: NewsComponentProps) {
    let labels: ProjectNewsLabels = {
        newsTitle: Translate('header/nav/news-component/title'),
        noNews: Translate('header/nav/news-component/no-news'),
        newItem: Translate('header/nav/news-component/new-item'),
        notificationTooltip: Translate('header/nav/news-component/notification-tooltip'),
        notificationTooltipSingular: Translate(
            'header/nav/news-component/notification-tooltip-singular'
        ),
        closeTooltip: Translate('header/nav/news-component/close-tooltip')
    };

    return <NewsComponent {...props} labels={labels} />;
}

export default TranslatedProjectNews;
